export default __webpack_public_path__ + "static/media/situation-coref-create-entity.214a6786.gif";